function LoadGraphs(){

  jQuery('canvas.graph').each(function(index, element) {
    
    let canvasDataId = jQuery(element).attr('data-id');
    if (canvasDataId) {
      let dataValues = canvasDataId.split('-');
      let minValue = parseInt(dataValues[0]);
      let maxValue = parseInt(dataValues[1]);
      let stepMin = minValue / 16;
      let stepMax = maxValue / 16;
      let labels = [];
      let datasetsDataMin = [];
      let datasetsDataMax = [];

      for (let i = 0; i <= 15; i++) {
        labels.push("Day " + (i * 2));
      }
      labels.push("");
      
      for (var i = 0; i <= 16; i++) {
        datasetsDataMin.push(i * stepMin);
      }
      
      for (var i = 0; i <= 16; i++) {
        datasetsDataMax.push(i * stepMax);
      }

      let ctx = element.getContext('2d');
      var chart = new Chart(ctx, {
          type: 'line',
          data: {
            labels: labels,
            datasets: [{
              label: 'Minimum',
              data: datasetsDataMin,
              borderColor: "white"
            }, {
              label: 'Maximum',
              data: datasetsDataMax,
              borderColor: "rgba(0, 173, 239, 1)"
            }]
          },
          options: {
            tooltips: {
              enabled: false,
            },
            scales: {
              yAxes: [{
                display: true,
                suggestedMin: 0,
                suggestedMax: parseInt(maxValue*2)
              }]
            }
          },
      });
    }
  });
  
}